import React from 'react'
import PropType from 'prop-types'
import './Loading.scss'

const Loading = ({ backdrop }) => {
  return (
    <div className={backdrop ? 'Loading-backdrop' : 'Loading'}>
      <div className="Loading-spinner">
        <div className="bounce1" />
        <div className="bounce2" />
        <div className="bounce3" />
      </div>
    </div>
  )
}

Loading.propTypes = {
  backdrop: PropType.bool,
}
export default Loading
